import { Container, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { useOriginClick } from 'services/datalayer/browse';

import CityCard from 'components/@cities/CityCard';
import { CityCardType } from 'components/@events/types';
import ScrollableList from 'components/@lists/ScrollableList';

interface Props {
  cities: Array<CityCardType>;
}

const HomeCities = ({ cities }: Props) => {
  const handleClick = useOriginClick('Cities', 'Discover');

  if (!cities?.length) return null;

  return (
    <Stack
      sx={{
        mb: { xs: 8, md: 15 },
      }}
    >
      <Container>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            mb: 2,
          }}
        >
          <FormattedMessage id="home.cities" />
        </Typography>
      </Container>
      <ScrollableList minWidthItem={{ xs: 220, md: 368 }} imageRefHeight={572}>
        {cities.map((city, idx) => (
          <CityCard
            key={city.id}
            city={city}
            priority={idx < 4}
            onClick={handleClick}
          />
        ))}
      </ScrollableList>
    </Stack>
  );
};

export default HomeCities;
